import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import {
    CTAAction,
    CTAActions
} from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { TApiAction } from "@/redux/store.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    product: CartItemModel | null;
    newQuantity: number;
};

const ChangeQuantitiesAction = ({ product, newQuantity }: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (product) {
            setLoading(true);
            dispatch(
                CartModule.updateCartItem(
                    product.id!,
                    newQuantity,
                    product.deliveryType,
                    product,
                    newQuantity - product.quantity
                )
            ).then((action: TApiAction) => {
                if (action.type === CartModule.APIStatus.SUCCESS) {
                    closeDialog();
                }
            });
        }
    }, []);

    return null;
};

const changeQuantities: CTAAction = (
    product: CartItemModel | null,
    action: CTAActions
) => {
    const newQuantity = action.productParameters[1];

    return (
        <ChangeQuantitiesAction
            product={product}
            newQuantity={newQuantity}
        />
    );
};

export default changeQuantities;
